/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustment_Reason_PlaceholderInputs */

const en_shipping_adjustment_reason_placeholder = /** @type {(inputs: Shipping_Adjustment_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explain the reason for the adjustment`)
};

const es_shipping_adjustment_reason_placeholder = /** @type {(inputs: Shipping_Adjustment_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explica el motivo del ajuste`)
};

/**
* | output |
* | --- |
* | "Explain the reason for the adjustment" |
*
* @param {Shipping_Adjustment_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustment_reason_placeholder = /** @type {((inputs?: Shipping_Adjustment_Reason_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustment_Reason_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustment_reason_placeholder(inputs)
	return es_shipping_adjustment_reason_placeholder(inputs)
});